/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable no-useless-escape */
import AddCircle from '@mui/icons-material/AddCircle';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
  Button,
  Checkbox,
  FormHelperText,
  TextField as MuiTextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { Theme, useTheme } from '@mui/material/styles';
import { isBefore } from 'date-fns';
import brLocale from 'date-fns/locale/pt-BR';
import moment from 'moment';
import React, { useEffect, useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';

import * as appStyles from '../../../AppStyle';
import compareDate from '../../../helpers/compareDate';
// Helpers
import toast from '../../../helpers/toast';
import { IRequester } from '../../../models/requester';
import { ITag } from '../../../models/tag';
import { ITopic } from '../../../models/topic';
import {
  createCompanyUnit,
  getAllCompanySize,
  ICompanySize,
  ICompanySizeDto,
  ICompanyUnit,
  ICompanyUnitDto,
} from '../../../services/company';
import { getAllCompanyUnit } from '../../../services/company';
import { createRequest, getAllRequesters } from '../../../services/requester';
import { createTag, getAllTags } from '../../../services/tags';
import { createTopics, getAllTopics } from '../../../services/topics';
import { dealWithTitleChange } from '../../../utils';
import CreationModal from '../../CreationModal/CreationModal';
import DraftEditor from '../../DraftEditor/DraftEditor';
import LastEditedBy from '../../LastEditedBy';
import UploadCover from '../../UploadCover';
import TextField from '../TextField';
import * as styles from './styles';

const ITEM_HEIGHT = 20;
const ITEM_PADDING_TOP = 100;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const namesVisibli = ['Restrito', 'Público'];

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const Content: React.FC<any> = (props: any) => {
  const router = useLocation();
  const contentId = router.search.split('&')[0];
  const [highlight, setHighlight] = React.useState(false);
  const theme = useTheme();

  const [visibility, setVisibility] = React.useState<string>('');

  const [requester, setRequester] = React.useState<string>('');
  const [companySize, setCompanySize] = React.useState<string[]>([]);

  const [companyUnit, setCompanyUnit] = React.useState<string[]>([]);
  const [topics, setTopics] = React.useState<string[]>([]);
  const [tags, setTags] = React.useState<string[]>([]);
  const [groups, setGroups] = React.useState<string[]>([]);
  const [antecipationGroup, setAntecipationGroup] = React.useState<string[]>(
    [],
  );
  const [antecipation, setAntecipation] = React.useState<boolean>(false);

  const [allCompanySize, setAllCompanySize] = React.useState<ICompanySize[]>(
    [],
  );
  const [allCompanyUnit, setAllCompanyUnit] = React.useState<ICompanyUnit[]>(
    [],
  );
  const [allRequesters, setAllRequesters] = React.useState<IRequester[] | []>(
    [],
  );
  const [allTags, setAllTags] = React.useState<ITag[] | []>([]);
  const [allTopics, setAllTopics] = React.useState<ITopic[] | []>([]);
  const allGroups = [
    { name: 'Cliente - Pessoa Física' },
    { name: 'Cliente - Pessoa Jurídica' },
  ];

  const [openModalTopic, setOpenModalTopic] = React.useState(false);
  const [openModalRequest, setOpenModalRequest] = React.useState(false);
  const [openModalTag, setOpenModalTag] = React.useState(false);
  const [openModalUnit, setOpenModalUnit] = React.useState(false);

  const Slugify = (text: string) => {
    return text
      .toLowerCase()
      .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a')
      .replace(/[èÈéÉêÊëË]+/g, 'e')
      .replace(/[ìÌíÍîÎïÏ]+/g, 'i')
      .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o')
      .replace(/[ùÙúÚûÛüÜ]+/g, 'u')
      .replace(/[ýÝÿŸ]+/g, 'y')
      .replace(/[ñÑ]+/g, 'n')
      .replace(/[çÇ]+/g, 'c')
      .replace(/[ß]+/g, 'ss')
      .replace(/[Ææ]+/g, 'ae')
      .replace(/[Øøœ]+/g, 'oe')
      .replace(/[%]+/g, 'pct')
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  };

  const { handleSubmit: handleRequestSubmit, control: controlRequest } =
    useForm();

  const { handleSubmit: handleTopicSubmit, control: controlTopic } = useForm();

  const {
    handleSubmit: handleTagSubmit,
    control: controlTag,
    setValue: setTagValue,
  } = useForm();

  const { handleSubmit: handleUnitSubmit, control: controlUnit } = useForm();

  function onTopicSubmit(data: any) {
    createTopics(data).then(res => {
      getTopics().then((topics: any) => {
        if (topics) {
          setAllTopics(topics.topics);
        }
        setOpenModalTopic(false);
      });
    });
  }

  function onRequestSubmit(data: any) {
    createRequest(data).then(res => {
      getAllRequesters().then(({ requesters }) => {
        if (requesters.length) {
          setAllRequesters(requesters);
        }
      });
      setOpenModalRequest(false);
    });
  }

  function onTagSubmit(data: any) {
    createTag(data).then(() => {
      getTags().then((tags: any) => {
        if (tags) {
          setAllTags(tags.tags);
        }
        setOpenModalTag(false);
      });
      setOpenModalTag(false);
    });
  }

  function onUnitSubmit(data: any) {
    createCompanyUnit(data).then(() => {
      getAllCompanyUnit().then((company_unit: any) => {
        if (company_unit) {
          setAllCompanyUnit(company_unit.companies_unit);
        }
        setOpenModalUnit(false);
      });
    });
  }

  useEffect(() => {
    if (visibility === 'public' || visibility === 'Público') {
      props.setValue('groups', null);
    }
  }, [visibility]);

  const fillTopics = () => {
    const editingTopics = props.content.topics;
    const selectedTopics: Array<any> = [];
    const selectedTopicsNames: string[] = [];

    editingTopics.forEach((topic: any) => {
      selectedTopics.push(topic?.topic_id);
      selectedTopicsNames.push(topic.name);
    });

    if (selectedTopics.length > 0) {
      props.setValue('topics', selectedTopics);
    }
    if (selectedTopicsNames.length > 0) {
      setTopics(selectedTopicsNames);
    }
  };

  const fillTags = () => {
    const editingTags = props.content.tags;
    const selectedTags: Array<any> = [];
    const selectedTagsNames: string[] = [];

    editingTags.forEach((tag: any) => {
      selectedTags.push(tag.tag_id);
      selectedTagsNames.push(tag.name);
    });

    if (selectedTags.length > 0) {
      props.setValue('tags', selectedTags);
    }
    if (selectedTagsNames.length > 0) {
      setTags(selectedTagsNames);
    }
  };

  const fillVisibi = () => {
    const editingVisibility = props.content.visibility;

    if (editingVisibility === 'public') {
      props.setValue('visibility', 'public');
      setVisibility('Público');
    } else {
      props.setValue('visibility', 'restricted');
      setVisibility('Restrito');
    }
  };

  const fillEditor = () => {
    const editingResume = props.content.resume;
    const editingDescription = props.content.description;

    if (editingResume) {
      props.setValue('resume', editingResume);
    }

    if (editingDescription) {
      props.setValue('description', editingDescription);
    }
  };

  const fillRequester = () => {
    const editingRequester = props.content?.requester;

    props.setValue('requester_id', editingRequester.requester_id);
    setRequester(editingRequester.name);
  };

  const fillCompanyUnits = () => {
    const editingCompany_units = props.content?.company_units;
    const selectedCompany_units: Array<any> = [];
    const selectedCompany_unitsNames: string[] = [];

    editingCompany_units.map((company_units: any) => {
      selectedCompany_units.push(company_units.company_unit_id);
      selectedCompany_unitsNames.push(company_units.name);
    });
    props.setValue('company_units', selectedCompany_units);
    setCompanyUnit(selectedCompany_unitsNames);
  };

  const fillPorts = () => {
    const editingCompanySizes = props.content.company_sizes;
    const selectedCompanySizes: Array<any> = [];
    const selectedCompanySizesNames: string[] = [];

    editingCompanySizes.forEach((ports: any) => {
      selectedCompanySizes.push(ports.company_size_id);
      selectedCompanySizesNames.push(ports.name);
    });

    if (selectedCompanySizes.length) {
      props.setValue('company_sizes', selectedCompanySizes);
    }
    if (selectedCompanySizesNames.length > 0) {
      setCompanySize(selectedCompanySizesNames);
    }
  };

  const fillGroup = () => {
    const editingGroup = props.content.groups;
    const selectedGroup: Array<any> = [];
    const mappedTag = new Map();

    mappedTag.set('MINIMAL', 'Cliente - Cadastro Mínimo');
    mappedTag.set('PHYSICAL', 'Cliente - Pessoa Física');
    mappedTag.set('LEGAL', 'Cliente - Pessoa Jurídica');
    mappedTag.set('EMPLOYEE', 'Colaborador Sebrae');

    if (editingGroup) {
      editingGroup.forEach((tag: any) => {
        selectedGroup.push(mappedTag.get(tag));
      });
      props.setValue('groups', editingGroup);
      setGroups(selectedGroup);
    }
  };

  interface TopicOption {
    readonly value: string;
    readonly label: string;
  }

  interface TopicOption {
    readonly value: string;
    readonly label: string;
  }

  const mappedTopics: readonly TopicOption[] = allTopics.map((u: any) => {
    return { value: u?.name, label: u?.name };
  });

  function handleTopicsChange(
    //@ts-ignore
    newValue: MultiValue<{
      value: string;
      label: string;
    }>,
  ) {
    const selectTopcisNames: Array<any> = newValue.map(topicOption => {
      return topicOption.value;
    });

    const select = selectTopcisNames[selectTopcisNames.length - 1];

    if (select.length <= 70) {
      setTopics(selectTopcisNames);

      const selectedTopics: any[] = [];
      allTopics?.forEach((topic: any) => {
        if (selectTopcisNames?.includes(topic.name)) {
          selectedTopics?.push(topic?.topic_id);
        }
      });

      if (selectedTopics?.length > 0) {
        props.setValue('topics', selectedTopics);
      }
    } else {
      toast({
        message:
          'Não é permitido selecionar mais um tópico. Ultrapassou 70 caracteres.',
        type: 'warning',
      });
    }
  }

  interface TagsOption {
    readonly value: string;
    readonly label: string;
  }

  const mappedTags: readonly TagsOption[] = allTags.map((u: any) => {
    return { value: u?.name, label: u?.name };
  });

  function handleTagsChange(
    //@ts-ignore
    newValue: MultiValue<{
      value: string;
      label: string;
    }>,
  ) {
    const selectTagsNames: Array<any> = newValue.map(tagOption => {
      return tagOption.value;
    });
    setTags(selectTagsNames);

    const selectedTags: any[] = [];
    allTags.forEach((tag: any) => {
      if (selectTagsNames.includes(tag.name)) {
        selectedTags.push(tag?.tag_id);
      }
    });

    if (selectedTags.length > 0) {
      props.setValue('tags', selectedTags);
    }

    return selectedTags.length > 0 ? selectedTags : undefined;
  }

  interface GroupsOption {
    readonly value: string;
    readonly label: string;
  }

  const mappedGroups: readonly GroupsOption[] = allGroups.map((u: any) => {
    return { value: u?.name, label: u?.name };
  });

  function handleGroupsChange(
    //@ts-ignore
    newValue: MultiValue<{
      value: string;
      label: string;
    }>,
  ) {
    const selectGroupsNames: Array<any> = newValue.map(tagOption => {
      return tagOption.value;
    });
    setGroups(selectGroupsNames);

    const selectedGroups: any[] = [];

    const mappedTag = new Map();

    mappedTag.set('Cliente - Cadastro Mínimo', 'MINIMAL');
    mappedTag.set('Cliente - Pessoa Física', 'PHYSICAL');
    mappedTag.set('Cliente - Pessoa Jurídica', 'LEGAL');
    mappedTag.set('Colaborador Sebrae', 'EMPLOYEE');

    allGroups.forEach((group: any) => {
      if (selectGroupsNames.includes(group.name)) {
        selectedGroups.push(mappedTag.get(group.name));
      }
    });

    if (selectedGroups.length > 0) {
      props.setValue('groups', selectedGroups);
    }

    return selectedGroups.length > 0 ? selectedGroups : undefined;
  }

  interface CompanyUnityOption {
    readonly value: string;
    readonly label: string;
  }

  const mappedCompanyUnity: readonly CompanyUnityOption[] = allCompanyUnit.map(
    (u: any) => {
      return { value: u?.name, label: u?.name };
    },
  );

  function handleCompanyUnityChange(
    //@ts-ignore
    newValue: MultiValue<{
      value: string;
      label: string;
    }>,
  ) {
    const selectCompanyUnitNames: Array<any> = newValue.map(
      CompanyUnityOption => {
        return CompanyUnityOption.value;
      },
    );
    setCompanyUnit(selectCompanyUnitNames);

    const selectedCompanyUnit: any[] = [];
    allCompanyUnit.forEach((companyUnity: any) => {
      if (selectCompanyUnitNames.includes(companyUnity.name)) {
        selectedCompanyUnit.push(companyUnity?.company_unit_id);
      }
    });

    if (selectedCompanyUnit.length > 0) {
      props.setValue('company_units', selectedCompanyUnit);
    }

    return selectedCompanyUnit.length > 0 ? selectedCompanyUnit : undefined;
  }

  interface CompanySizeOption {
    readonly value: string;
    readonly label: string;
  }

  const mappedCompanySize: readonly CompanySizeOption[] = allCompanySize.map(
    (u: any) => {
      return { value: u?.name, label: u?.name };
    },
  );

  function handleCompanySizeChange(
    //@ts-ignore
    newValue: MultiValue<{
      value: string;
      label: string;
    }>,
  ) {
    const selectCompanySizeNames: Array<any> = newValue.map(
      CompanySizeOption => {
        return CompanySizeOption.value;
      },
    );
    setCompanySize(selectCompanySizeNames);

    const selectedCompanySize: any[] = [];
    allCompanySize.forEach((companySize: any) => {
      if (selectCompanySizeNames.includes(companySize.name)) {
        selectedCompanySize.push(companySize?.company_size_id);
      }
    });

    if (selectedCompanySize.length > 0) {
      props.setValue('company_sizes', selectedCompanySize);
    }

    return selectedCompanySize.length > 0 ? selectedCompanySize : undefined;
  }

  useEffect(() => {
    getTags();
    getTopics();
    getRequests();
    getCompanySize();
    getCompanyUnit();

    props.setValue('categories', []);

    if (props.content != null) {
      props.setValue('page_title', props.content.page_title);
      props.setValue('slug', Slugify(props.content.slug));
      props.setValue('title', props.content.title);
      props.setValue('subtitle', props.content.subtitle);
      props.setValue('resume', props.content.resume);
      props.setValue('published_end_at', props.content.published_end_at);
      props.setValue('published_start_at', props.content.published_start_at);

      if (props.content.part) {
        props.setValue('part', props.content.part);
      }
      if (props.content.edition) {
        props.setValue('edition', props.content.edition);
      }
      if (props.content.extension) {
        props.setValue('extension', props.content.extension);
      }

      fillTopics();
      fillTags();
      fillVisibi();
      fillRequester();
      fillPorts();
      fillCompanyUnits();
      fillGroup();
      fillEditor();
      props.setValue('image_toltip', props?.content?.image_toltip);
      props.setValue('image_name', props?.content?.image_name);
      props.setValue('review_in', props.content.review_in);

      const isHighlight =
        moment(new Date()).isBefore(moment(props?.content?.featured_end_at)) &&
        moment(new Date()).isAfter(moment(props?.content?.featured_start_at));

      setHighlight(isHighlight);
      props.setValue('featured_start_at', props.content.featured_start_at);
      props.setValue('featured_end_at', props.content.featured_end_at);

      if (props.content.featured_start_at || props.content.featured_end_at) {
        setHighlight(true);
      }
    }
  }, []);

  const handleChangeSelectVisibility = event => {
    setVisibility(event.target.value);
  };

  const handleChangeSelectGroup = event => {
    const editingGroup = event.target.value;

    const selectedGroup: Array<any> = [];
    const value = event.target.value;
    const mappedTag = new Map();

    mappedTag.set('Cliente - Cadastro Mínimo', 'MINIMAL');
    mappedTag.set('Cliente - Pessoa Física', 'PHYSICAL');
    mappedTag.set('Cliente - Pessoa Jurídica', 'LEGAL');
    mappedTag.set('Colaborador Sebrae', 'EMPLOYEE');

    if (editingGroup) {
      editingGroup.forEach((tag: any) => {
        selectedGroup.push(mappedTag.get(tag));
      });

      props.setValue('groups', selectedGroup);
      setGroups(value);
    }
  };

  const handleChangeSelectAntecipationGroup = event => {
    const editingGroup = event.target.value;

    const selectedGroup: Array<any> = [];
    const value = event.target.value;
    const mappedTag = new Map();

    mappedTag.set('Cliente - Cadastro Mínimo', 'MINIMAL');
    mappedTag.set('Cliente - Pessoa Física', 'PHYSICAL');
    mappedTag.set('Cliente - Pessoa Jurídica', 'LEGAL');
    mappedTag.set('Colaborador Sebrae', 'EMPLOYEE');

    if (editingGroup) {
      editingGroup.forEach((tag: any) => {
        selectedGroup.push(mappedTag.get(tag));
      });
      props.setValue(
        'antecipation_groups',
        selectedGroup ? selectedGroup : [null],
      );
      setAntecipationGroup(value);
    }
  };

  const handleChangeHighlight = event => {
    setHighlight(event);
  };

  const getTags = async () => {
    getAllTags().then(({ data: tags }) => {
      if (tags.length) {
        setAllTags(tags);
      }
    });
  };

  const getTopics = async () => {
    getAllTopics().then(({ data: topics }) => {
      if (topics.length) {
        setAllTopics(topics);
      }
    });
  };

  const getRequests = async () => {
    getAllRequesters().then(requesters => {
      if (requesters) {
        setAllRequesters(requesters.requesters);
      }
    });
  };

  const getCompanySize = async () => {
    getAllCompanySize().then((companySizeDto: ICompanySizeDto) => {
      if (companySizeDto) {
        setAllCompanySize(companySizeDto.companies_size);
      }
    });
  };

  const getCompanyUnit = async () => {
    getAllCompanyUnit().then((companyUnitDto: ICompanyUnitDto) => {
      if (companyUnitDto) {
        setAllCompanyUnit(companyUnitDto.companies_unit);
      }
    });
  };

  const verifyIfContentIsCreated = useMemo(() => {
    if (props.content) {
      return;
    }

    return new Date();
  }, [props?.content]);

  const handleRemoveAntecipationGroups = () => {
    props.setValue('antecipation_groups', null);
  };

  useEffect(() => {
    handleRemoveAntecipationGroups();
  }, [props.getValues('antecipation')]);

  return (
    <styles.CreateAndEditContentContainer>
      <styles.ContainerData>
        <Typography variant="h4" style={{ marginBottom: '22px' }}>
          Conteúdo
        </Typography>
        {contentId && <LastEditedBy content_id={contentId} />}
      </styles.ContainerData>
      <form>
        <styles.ContentSeletor>
          <Box
            component="div"
            sx={{
              '& .MuiTextField-root': { m: 0, width: '100%' },
            }}
          >
            <styles.Label>Título da página *</styles.Label>
            <Controller
              name="page_title"
              control={props.control}
              rules={{
                required: true,
                maxLength: 55,
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.InputText
                    inputProps={{ maxLength: 55 }}
                    disabled={props.view}
                    name="page_title"
                    value={value}
                    onChange={event => {
                      const slug = dealWithTitleChange(event.target.value);
                      props.setValue('slug', Slugify(slug));
                      onChange(event);
                    }}
                    required
                    id="outlined-required"
                  />
                  {value?.length === 55 ? (
                    <FormHelperText id="outlined-required">
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        Tamanho máximo de 55 caracteres
                      </appStyles.inputLabel>
                    </FormHelperText>
                  ) : (
                    ''
                  )}
                  {error !== undefined ? (
                    error.type === 'required' ? (
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        *Campo obrigatório
                      </appStyles.inputLabel>
                    ) : (
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        Tamanho máximo de 55 caracteres
                      </appStyles.inputLabel>
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
            />
          </Box>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <Box
            component="div"
            sx={{
              '& .MuiTextField-root': { m: 0, width: '100%' },
            }}
          >
            <styles.Label>Slug/URL</styles.Label>
            <Controller
              name="slug"
              control={props.control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <styles.InputText
                  disabled={props.view}
                  onClick={() => {
                    alert(
                      'A alteração pode ser prejudicial ao ranqueamento das ferramentas de busca.',
                    );
                  }}
                  name="slug"
                  value={value}
                  onChange={onChange}
                  required
                  id="outlined-required"
                />
              )}
            />
          </Box>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <Box
            component="div"
            sx={{
              '& .MuiTextField-root': { m: 0, width: '100%' },
            }}
          >
            <styles.Label>Título do conteúdo *</styles.Label>
            <Controller
              name="title"
              control={props.control}
              rules={{
                required: true,
                maxLength: 70,
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.InputText
                    disabled={props.view}
                    name="title"
                    value={value}
                    inputProps={{ maxLength: 70 }}
                    onChange={event => {
                      props.setValue(
                        'image_name',
                        'Sebrae Minas - ' + event.target.value,
                      );
                      props.setValue(
                        'image_toltip',
                        'Sebrae Minas - ' + event.target.value,
                      );
                      onChange(event);
                    }}
                    required
                    id="outlined-required"
                  />

                  {value?.length === 70 ? (
                    <FormHelperText id="outlined-required">
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        Tamanho máximo de 70 caracteres
                      </appStyles.inputLabel>
                    </FormHelperText>
                  ) : (
                    ''
                  )}
                  {error !== undefined ? (
                    error.type === 'required' ? (
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        *Campo obrigatório
                      </appStyles.inputLabel>
                    ) : (
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        Tamanho máximo de 70 caracteres
                      </appStyles.inputLabel>
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
            />
          </Box>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <Box
            component="div"
            sx={{
              '& .MuiTextField-root': { m: 0, width: '100%' },
            }}
          >
            <styles.Label>Subtítulo *</styles.Label>
            <Controller
              name="subtitle"
              control={props.control}
              rules={{
                required: true,
                maxLength: 160,
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.InputText
                    disabled={props.view}
                    name="subtitle"
                    value={value}
                    inputProps={{ maxLength: 160 }}
                    onChange={event => {
                      onChange(event);
                    }}
                    id="outlined-required"
                  />
                  {value?.length === 160 ? (
                    <FormHelperText id="outlined-required">
                      <appStyles.inputLabel
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        Tamanho máximo de 160 caracteres
                      </appStyles.inputLabel>
                    </FormHelperText>
                  ) : (
                    ''
                  )}
                  {error !== undefined ? (
                    <appStyles.inputLabel
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.inputLabel>
                  ) : (
                    <></>
                  )}
                </>
              )}
            />
          </Box>
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <Box
            component="div"
            sx={{
              '& .MuiTextField-root': { m: 0, width: '100%' },
            }}
          >
            <styles.Label>Resumo *</styles.Label>
            <Controller
              name="resume"
              control={props.control}
              rules={{
                validate: {
                  required: fieldValue =>
                    (fieldValue && fieldValue.length > 0) ||
                    '*Campo obrigatório',
                  maxLength: fieldValue =>
                    (fieldValue && fieldValue.length <= 160) ||
                    'Tamanho deve ser inferior a 160 caracteres',
                },
              }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.InputText
                    disabled={props.view}
                    name="resume"
                    value={value}
                    onChange={onChange}
                    required
                    id="outlined-required"
                  />
                  {error !== undefined && (
                    <appStyles.inputLabel
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      {error.message}
                    </appStyles.inputLabel>
                  )}
                </>
              )}
            />
          </Box>
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <styles.Label>Descrição *</styles.Label>
          <Controller
            name="description"
            control={props.control}
            rules={{
              validate: {
                required: fieldValue =>
                  (fieldValue &&
                    fieldValue.replace(/<[^>]+>/g, '').length > 1) ||
                  '*Campo obrigatório',
              },
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <DraftEditor
                  name={'description'}
                  setValue={props.setValue}
                  value={value}
                />
                {error !== undefined && (
                  <appStyles.inputLabel
                    style={{ color: 'red', marginBottom: '0.5rem' }}
                  >
                    {error.message}
                  </appStyles.inputLabel>
                )}
              </>
            )}
          />
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <styles.Label>Tópicos</styles.Label>
          </div>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="topics"
              control={props.control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    isMulti
                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                    menuPlacement="auto"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    onChange={handleTopicsChange}
                    options={mappedTopics}
                    placeholder="Tópicos selecionados"
                    value={topics.map(topic => {
                      return { value: topic, label: topic };
                    })}
                  />
                </>
              )}
            />
          </FormControl>
          <Button
            onClick={() => setOpenModalTopic(true)}
            startIcon={<AddCircle />}
            variant="contained"
            size="small"
            style={{
              maxWidth: '166px',
            }}
          >
            <span>Adicionar novo</span>
          </Button>
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <styles.Label>Tags *</styles.Label>

          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="tags"
              control={props.control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    isMulti
                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                    menuPlacement="auto"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    onChange={event => {
                      onChange(handleTagsChange(event));
                    }}
                    options={mappedTags}
                    placeholder="Tags selecionadas"
                    value={tags.map(tag => {
                      return { value: tag, label: tag };
                    })}
                  />
                  {error !== undefined ? (
                    <appStyles.span
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.span>
                  ) : (
                    <></>
                  )}
                </>
              )}
            />
          </FormControl>

          <Button
            onClick={() => setOpenModalTag(true)}
            startIcon={<AddCircle />}
            variant="contained"
            size="small"
            style={{
              maxWidth: '166px',
            }}
          >
            <span>Adicionar novo</span>
          </Button>
        </styles.ContentSeletor>

        <TextField label="Capa (Tamanho 1035x526px)" name="image_file_id">
          <UploadCover
            isView={props.view}
            sizes={{
              width: 1035,
              heigth: 526,
            }}
            showCategory
          />
        </TextField>

        <styles.ContentSeletor>
          <styles.Label>Visibilidade *</styles.Label>

          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="visibility"
              rules={{ required: true }}
              control={props.control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.SelectorSelect
                    disabled={props.view}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    name="visibility"
                    value={visibility}
                    onChange={event => {
                      handleChangeSelectVisibility(event);
                      if (event.target.value === 'Restrito') {
                        event.target.value = 'restricted';
                      } else event.target.value = 'public';
                      props.setValue('visibility', event.target.value);
                      onChange(event.target.value);
                    }}
                    MenuProps={MenuProps}
                  >
                    {namesVisibli.map(name => (
                      <styles.MenuItemSelector
                        key={name}
                        value={name}
                        style={getStyles(name, tags, theme)}
                      >
                        {name}
                      </styles.MenuItemSelector>
                    ))}
                  </styles.SelectorSelect>
                  {error !== undefined ? (
                    <appStyles.inputLabel
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.inputLabel>
                  ) : (
                    <></>
                  )}
                </>
              )}
            />
          </FormControl>
        </styles.ContentSeletor>

        {visibility === 'Restrito' && (
          <styles.ContentSeletor>
            <styles.Label>Grupos</styles.Label>
            <FormControl sx={{ width: '100%' }}>
              <Controller
                name="groups"
                control={props.control}
                rules={{ required: visibility === 'Restrito' ? true : false }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <>
                    <Select
                      isMulti
                      noOptionsMessage={() => 'Nenhuma opção encontrada'}
                      menuPlacement="auto"
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                      isRtl={false}
                      isSearchable={true}
                      onChange={event => {
                        onChange(handleGroupsChange(event));
                      }}
                      options={mappedGroups}
                      placeholder="Grupos selecionados"
                      value={groups.map(group => {
                        return { value: group, label: group };
                      })}
                    />
                    {error !== undefined ? (
                      <appStyles.span
                        style={{ color: 'red', marginBottom: '0.5rem' }}
                      >
                        *Campo obrigatório
                      </appStyles.span>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              />
            </FormControl>
          </styles.ContentSeletor>
        )}

        <styles.ContentInput>
          <Checkbox
            id="highlight"
            checked={highlight}
            onChange={event => handleChangeHighlight(event.target.checked)}
          />
          <styles.Label htmlFor="highlight">Destaque</styles.Label>
        </styles.ContentInput>
        {highlight ? (
          <>
            <styles.ContentSeletor>
              <styles.Label>Data destaque início</styles.Label>
              <FormControl sx={{ width: '100%' }}>
                <Controller
                  name="featured_start_at"
                  control={props.control}
                  rules={{ required: '*Campo obrigatório' }}
                  render={({
                    field: { onChange, value = null },
                    fieldState: { error },
                  }) => (
                    <>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={brLocale}
                      >
                        <DatePicker
                          disabled={props.view}
                          label="Data destaque início"
                          value={value}
                          onChange={onChange}
                          renderInput={params => <MuiTextField {...params} />}
                        />
                      </LocalizationProvider>

                      {error !== undefined && (
                        <appStyles.span
                          style={{ color: 'red', marginBottom: '0.5rem' }}
                        >
                          {error.message}
                        </appStyles.span>
                      )}
                    </>
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
            <styles.ContentSeletor>
              <styles.Label>Data destaque fim</styles.Label>
              <FormControl sx={{ width: '100%' }}>
                <Controller
                  name="featured_end_at"
                  control={props.control}
                  rules={{
                    required: '*Campo obrigatório',
                    validate: value => {
                      if (
                        compareDate(props.getValues('featured_start_at'), value)
                      ) {
                        return '*A data de destaque fim não deve ser menor que a data de destaque início. ';
                      } else {
                        true;
                      }
                    },
                  }}
                  render={({
                    field: { onChange, value = null },
                    fieldState: { error },
                  }) => (
                    <>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={brLocale}
                      >
                        <DatePicker
                          disabled={props.view}
                          label="Data destaque fim"
                          value={value}
                          onChange={onChange}
                          renderInput={params => <MuiTextField {...params} />}
                        />
                      </LocalizationProvider>
                      {error !== undefined && (
                        <appStyles.span
                          style={{ color: 'red', marginBottom: '0.5rem' }}
                        >
                          {error.message}
                        </appStyles.span>
                      )}
                    </>
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>{' '}
          </>
        ) : (
          <></>
        )}
        <styles.ContentSeletor>
          <styles.Label>Data publicação início</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="published_start_at"
              control={props.control}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={brLocale}
                  >
                    <DatePicker
                      disabled={props.view}
                      minDate={verifyIfContentIsCreated}
                      label="Data publicação início"
                      value={value}
                      onChange={onChange}
                      renderInput={params => <MuiTextField {...params} />}
                    />
                  </LocalizationProvider>
                </>
              )}
            />
          </FormControl>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <styles.Label>Data publicação fim</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="published_end_at"
              control={props.control}
              rules={{
                validate: value => {
                  if (
                    compareDate(props.getValues('published_start_at'), value)
                  ) {
                    return '*A data de publicação fim não deve ser menor que a data de publicação início. ';
                  } else {
                    true;
                  }
                },
              }}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={brLocale}
                  >
                    <DatePicker
                      disabled={props.view}
                      label="Data publicação fim"
                      minDate={verifyIfContentIsCreated}
                      value={value}
                      onChange={onChange}
                      renderInput={params => <MuiTextField {...params} />}
                    />
                  </LocalizationProvider>
                  {error !== undefined && (
                    <appStyles.span
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      {error.message}
                    </appStyles.span>
                  )}
                </>
              )}
            />
          </FormControl>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <styles.Label>Data de Revisão *</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="review_in"
              control={props.control}
              rules={{
                required: '*Campo obrigatório',
                validate: value => {
                  if (isBefore(props.getValues('review_in'), new Date())) {
                    return '*A data de revisão não deve ser anterior a data de hoje';
                  }
                  if (
                    compareDate(props.getValues('published_start_at'), value)
                  ) {
                    return '*A data de revisão não deve ser menor que a data de publicação início.';
                  } else {
                    true;
                  }
                },
              }}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <>
                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={brLocale}
                  >
                    <DatePicker
                      disabled={props.view}
                      label="Data de Revisão *"
                      value={value}
                      onChange={onChange}
                      renderInput={params => <MuiTextField {...params} />}
                    />
                    {error !== undefined && (
                      <span style={{ color: 'red', marginBottom: '0.5rem' }}>
                        {error.message}
                      </span>
                    )}
                  </LocalizationProvider>
                </>
              )}
            />
          </FormControl>
        </styles.ContentSeletor>
        <styles.ContentSeletor>
          <styles.Label>Solicitante *</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="requester_id"
              control={props.control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <styles.SelectorSelect
                    disabled={props.view}
                    name="requester_id"
                    value={requester}
                    onChange={(event: any) => {
                      setRequester(event?.target?.value);
                      const selectedRequester: any = allRequesters.find(
                        (element: any) => {
                          return element.name === event.target.value;
                        },
                      );

                      onChange(selectedRequester.requester_id);
                    }}
                    MenuProps={MenuProps}
                  >
                    {allRequesters.map((currentRequester: any, index) => (
                      <styles.MenuItemSelector
                        key={index}
                        value={currentRequester.name}
                      >
                        {currentRequester.name}
                      </styles.MenuItemSelector>
                    ))}
                  </styles.SelectorSelect>
                  {error !== undefined && (
                    <appStyles.inputLabel
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.inputLabel>
                  )}
                </>
              )}
            />
          </FormControl>
          <Button
            onClick={() => setOpenModalRequest(true)}
            startIcon={<AddCircle />}
            variant="contained"
            size="small"
            style={{
              maxWidth: '166px',
            }}
          >
            <span>Adicionar novo</span>
          </Button>
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <styles.Label>Portes *</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="company_sizes"
              control={props.control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    isMulti
                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                    menuPlacement="auto"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    onChange={event => {
                      onChange(handleCompanySizeChange(event));
                    }}
                    options={mappedCompanySize}
                    placeholder="Portes selecionados"
                    value={companySize.map(companySize => {
                      return { value: companySize, label: companySize };
                    })}
                  />
                  {error !== undefined && (
                    <appStyles.span
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.span>
                  )}
                </>
              )}
            />
          </FormControl>
        </styles.ContentSeletor>

        <styles.ContentSeletor>
          <styles.Label>Unidades *</styles.Label>
          <FormControl sx={{ width: '100%' }}>
            <Controller
              name="company_units"
              control={props.control}
              rules={{ required: true }}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <>
                  <Select
                    isMulti
                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                    menuPlacement="auto"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    onChange={event => {
                      onChange(handleCompanyUnityChange(event));
                    }}
                    options={mappedCompanyUnity}
                    placeholder="Unidades selecionados"
                    value={companyUnit.map(companyUnit => {
                      return { value: companyUnit, label: companyUnit };
                    })}
                  />
                  {error !== undefined && (
                    <appStyles.span
                      style={{ color: 'red', marginBottom: '0.5rem' }}
                    >
                      *Campo obrigatório
                    </appStyles.span>
                  )}
                </>
              )}
            />
          </FormControl>

          <Button
            onClick={() => setOpenModalUnit(true)}
            startIcon={<AddCircle />}
            variant="contained"
            size="small"
            style={{
              maxWidth: '166px',
            }}
          >
            <span>Adicionar novo</span>
          </Button>
        </styles.ContentSeletor>

        <Box
          component="div"
          sx={{
            '& .MuiTextField-root': { m: 0, width: '100%' },
          }}
        >
          <styles.ContentInput>
            <Checkbox
              id="antecipation"
              checked={antecipation}
              onChange={event => {
                setAntecipation(!antecipation);
                props.setValue('antecipation', event.target.checked);
              }}
            />
            <styles.Label htmlFor="antecipation">
              Antecipar publicação
            </styles.Label>
          </styles.ContentInput>
        </Box>
        {antecipation && (
          <>
            <styles.ContentSeletor>
              <Box
                component="div"
                sx={{
                  '& .MuiTextField-root': { width: '100%' },
                }}
              >
                <styles.Label>Dias de antecipação</styles.Label>
                <Controller
                  name="antecipation_days"
                  control={props.control}
                  rules={{ required: true }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <styles.InputText
                      name="antecipation_days"
                      value={value}
                      type="number"
                      onChange={onChange}
                      required
                      id="outlined-required"
                    />
                  )}
                />
              </Box>
            </styles.ContentSeletor>
            <styles.ContentSeletor>
              <styles.Label>Grupos</styles.Label>
              <FormControl sx={{ width: '100%' }}>
                <styles.SelectorSelect
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  name="antecipation_groups"
                  value={antecipationGroup}
                  multiple
                  onChange={(event: any) => {
                    handleChangeSelectAntecipationGroup(event);
                  }}
                >
                  <styles.MenuItemSelector value={'Cliente - Pessoa Física'}>
                    {'Cliente - Pessoa Física'}
                  </styles.MenuItemSelector>
                  <styles.MenuItemSelector value={'Cliente - Pessoa Jurídica'}>
                    {'Cliente - Pessoa Jurídica'}
                  </styles.MenuItemSelector>
                </styles.SelectorSelect>
              </FormControl>
            </styles.ContentSeletor>
          </>
        )}

        <CreationModal
          title="Tópicos"
          modalOpen={openModalTopic}
          setModalOpen={setOpenModalTopic}
          handleSubmit={handleTopicSubmit(onTopicSubmit)}
        >
          <>
            <styles.ContentSeletor>
              <styles.Label>Nome Tópico *</styles.Label>
              <FormControl sx={{ m: 1, width: '100%' }}>
                <Controller
                  name="name"
                  control={controlTopic}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <>
                      <styles.InputText
                        name="name"
                        value={value}
                        inputProps={{ maxLength: 70 }}
                        onChange={onChange}
                        required
                        id="outlined-required"
                      />
                      {value?.length === 70 ? (
                        <FormHelperText id="outlined-required">
                          <appStyles.span
                            style={{ color: 'red', marginBottom: '0.5rem' }}
                          >
                            Tamanho máximo de 70 caracteres
                          </appStyles.span>
                        </FormHelperText>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
          </>
        </CreationModal>

        <CreationModal
          title="Solicitante"
          modalOpen={openModalRequest}
          setModalOpen={setOpenModalRequest}
          handleSubmit={handleRequestSubmit(onRequestSubmit)}
        >
          <>
            <styles.ContentSeletor>
              <styles.Label>Nome Solicitante *</styles.Label>
              <FormControl sx={{ m: 1, width: '100%' }}>
                <Controller
                  name="name"
                  control={controlRequest}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <styles.InputText
                      name="name"
                      value={value}
                      onChange={onChange}
                      required
                      id="outlined-required"
                    />
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
          </>
        </CreationModal>

        <CreationModal
          title="Tags"
          modalOpen={openModalTag}
          setModalOpen={setOpenModalTag}
          handleSubmit={handleTagSubmit(onTagSubmit)}
        >
          <>
            <styles.ContentSeletor>
              <styles.Label>Nome Tag *</styles.Label>
              <FormControl sx={{ m: 1, width: '100%' }}>
                <Controller
                  name="name"
                  control={controlTag}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <styles.InputText
                      name="name"
                      value={value}
                      onChange={event => {
                        let slug = event?.target?.value?.toLowerCase();
                        slug = slug?.replace(' ', '-');
                        setTagValue('slug', Slugify(slug));
                        onChange(event);
                      }}
                      required
                      id="outlined-required"
                    />
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
            <styles.ContentSeletor>
              <styles.Label>Slug *</styles.Label>
              <FormControl sx={{ m: 1, width: '100%' }}>
                <Controller
                  name="slug"
                  control={controlTag}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <styles.InputText
                      name="slug"
                      value={value}
                      onChange={onChange}
                      required
                      id="outlined-required"
                    />
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
          </>
        </CreationModal>

        <CreationModal
          title="Unidade"
          modalOpen={openModalUnit}
          setModalOpen={setOpenModalUnit}
          handleSubmit={handleUnitSubmit(onUnitSubmit)}
        >
          <>
            <styles.ContentSeletor>
              <styles.Label>Nome *</styles.Label>
              <FormControl sx={{ m: 1, width: '100%' }}>
                <Controller
                  name="name"
                  control={controlUnit}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <styles.InputText
                      name="name"
                      value={value}
                      onChange={onChange}
                      required
                      id="outlined-required"
                    />
                  )}
                />
              </FormControl>
            </styles.ContentSeletor>
          </>
        </CreationModal>

        {props.children !== undefined && props.children}
      </form>
    </styles.CreateAndEditContentContainer>
  );
};

export default Content;
